import { useEffect, useRef } from 'react'

export const useTrackingStyles = (css?: string) => {
  const styleRef = useRef<HTMLStyleElement | null>(null)

  useEffect(() => {
    if (!css) {
      return
    }

    const style = document.createElement('style')
    style.setAttribute('type', 'text/css')
    style.textContent = css

    styleRef.current = style

    document.head.appendChild(style)

    return () => {
      if (styleRef.current) {
        document.head.removeChild(styleRef.current)
      }
    }
  }, [])
}

export default useTrackingStyles
